import { render, staticRenderFns } from "./AssetItem.vue?vue&type=template&id=50360436"
import script from "./AssetItem.vue?vue&type=script&lang=js"
export * from "./AssetItem.vue?vue&type=script&lang=js"
import style0 from "./AssetItem.vue?vue&type=style&index=0&id=50360436&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports